/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'

import axios from 'axios'
import { Link } from 'react-router-dom'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'


import { viewBumbleProfileJSX } from '../profile/view/bumble/viewBumbleProfileTabJSX'
import { viewHingeProfileJSX } from '../profile/view/hinge/viewHingeProfileTabJSX'
import { viewTinderProfileJSX } from '../profile/view/tinder/viewTinderProfileTabJSX'

import { viewReviewerJSX } from './jsx/viewReviewerJSX'

import useWindowDimensions from '../../helpers/windowDimensions'
import { getPayload, userIsAuthenticated, getTokenFromLocalStorage } from '../../helpers/storage'
import { seoPageTags, registerPageViewsInsideMetaBrowser } from '../../helpers/analytics'
import { standardSpinner } from '../../helpers/spinners'
import { navbarHeight, dashboardNavbarHeight, footerHeight, positionChangeWidthSm, hingeProfileBackgroundColor } from '../../helpers/variableDefaults'
import { makeTabIndex } from '../../helpers/formatting'
import { standardButton } from '../../helpers/buttons'
import { isInstagramOrFacebook } from '../../helpers/globalHelpers'

// View Feedback Page
const ViewFeedback = (props) => {

  const { isDemo, demoUser, profileType, reviewerFirstName } = props
  
  // Window Dimensions
  const { height, width } = useWindowDimensions()
  
  // Navigate
  const navigate = useNavigate()

  // Params
  const { userId, reviewerUserId, datingProfileId, profileReviewId } = useParams()

  // URL Path
  const urlPath = window.location.pathname
  const urlPathEnding = urlPath.split('/').pop()
  const isReviewer = urlPathEnding === 'view-past-review' ? true : false

  const location = useLocation()
  const previousLocationPathname = 'state' in location && location.state !== null && location.state !== undefined && 'previousLocationPathname' in location.state ? location.state.previousLocationPathname : ''
  const fromHomepage = isDemo && previousLocationPathname && previousLocationPathname.includes('homepage') ? true : false
  // console.log('previousLocationPathname ->', previousLocationPathname)
  // console.log('fromHomepage ->', fromHomepage)

  // Payload
  const payload = getPayload()

  // Dashboard Navigation
  const [user, setUser] = useState({})
  // const [datingProfile, setDatingProfile] = useState({})
  const [profileReview, setProfileReview] = useState({})
  // const [viewIndex, setViewIndex] = useState(previousLocationPathname && previousLocationPathname.includes('media-item') ? 1 : 0)

  const [viewTinderImageIndex, setViewTinderImageIndex] = useState(0)

  const [showSubcaption, setShowSubcaption] = useState({
    mediaItem1: false,
    mediaItem2: false,
    mediaItem3: false,
    mediaItem4: false,
    mediaItem5: false,
    mediaItem6: false,
    mediaItem7: false,
    mediaItem8: false,
    mediaItem9: false,
  })
  const [mediaIsLoading, setMediaIsLoading] = useState({
    mediaItem1: false,
    mediaItem2: false,
    mediaItem3: false,
    mediaItem4: false,
    mediaItem5: false,
    mediaItem6: false,
    mediaItem7: false,
    mediaItem8: false,
    mediaItem9: false,
  })

  const [newReviewerReview, setNewReviewerReview] = useState({
    email: '',
    profileReviewId: '',
    reviewerProfileId: '',
    starRating: -1,
    reviewText: '',
    profileReviewedFirstName: '',
  })

  // Loading
  const [loading, setLoading] = useState(false)
  const [loadingReviewerReview, setLoadingReviewerReview] = useState(false)

  // Errors
  const [errors, setErrors] = useState(false)
  const [reviewerReviewErrors, setReviewerReviewErrors] = useState(false)

  useEffect(() => {
    if (isDemo) {
      console.log('demoUser ->', demoUser)

      setUser({ ...demoUser })
      const profileReviewToSet = demoUser.datingProfiles.filter((profile, index) => profile.type.toLowerCase() === profileType.toLowerCase())[0].profileReviews.filter((profileReview, reviewIndex) => profileReview.reviewerProfile.bio.vitalInfo.firstName.toLowerCase().replace(/ /g,'') === reviewerFirstName.toLowerCase().replace(/ /g,''))[0]
      
      console.log('profile type ->', profileType.toLowerCase())
      console.log('profileReviewToSet ->', profileReviewToSet)
      console.log('first name ->', profileReviewToSet.bio.vitalInfo.firstName)
      setProfileReview({ ...profileReviewToSet })


      const checkForMetaBrowser = () => {
        if (isInstagramOrFacebook()) {
          const timeout = setTimeout(() => {
            // console.log('⏱️ Delayed effect: 250ms later');
            // Put your delayed logic here
            registerPageViewsInsideMetaBrowser(`Demo — ${profileReviewToSet.bio.vitalInfo.firstName}`)
          }, 250) // delay in milliseconds
  
          return () => clearTimeout(timeout)
        }
      }
      
      checkForMetaBrowser()

    } else if (!userIsAuthenticated() || !userId || !reviewerUserId) {
      console.log('user not authenticated')
      navigate(`/login`)
    } else if ((isReviewer) && (reviewerUserId !== payload.sub) && payload.sub.toString() !== process.env.REACT_APP_ADMIN_USER_ID) {
      console.log('different userIds reviewer')
      navigate(`/dashboard/${payload.sub}`)
    } else if ((!isReviewer) && (userId !== payload.sub) && payload.sub.toString() !== process.env.REACT_APP_ADMIN_USER_ID) {
      console.log('different userIds client')
      navigate(`/dashboard/${payload.sub}`)
      // reloadView()
    } else {
      const fetchData = async () => {
        setLoading(true)
        // console.log('userId ->', userId)

        if (
          payload.sub.toString() === process.env.REACT_APP_ADMIN_USER_ID
          && userId !== payload.sub
          && reviewerUserId !== payload.sub
        ) {
          console.log('admin is viewer')
          try {
            const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/profile-reviews/${profileReviewId}`, {
              headers: {
                Authorization: `Bearer ${getTokenFromLocalStorage()}`,
              },
            })
            // console.log('data ->', data)
            // console.log('data.user ->', data.user)
            // console.log('data.profileReview ->', data.profileReview)
            setUser(data.user)
            setProfileReview(data.profileReview)

            setLoading(false)
          } catch (err) {
            // console.log(err)

            navigate('/')
            setLoading(false)
          }
        } else {

          try {
            const { data: retrievedUser } = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/users/${payload.sub}`, {
              headers: {
                Authorization: `Bearer ${getTokenFromLocalStorage()}`,
              },
            })
            // console.log('retrievedUser ->', retrievedUser)

            if (
              isReviewer
              && retrievedUser._id === payload.sub
              && 'reviewerProfile' in retrievedUser
              && 'profileReviews' in retrievedUser.reviewerProfile 
              && retrievedUser.reviewerProfile.profileReviews !== null
              && retrievedUser.reviewerProfile.profileReviews.length > 0
              && retrievedUser.reviewerProfile.profileReviews.filter((profileReview, reviewIndex) => profileReview._id === profileReviewId).length > 0
            ) {
              // console.log('states should set - reviewer')
              // Set User State
              setUser(retrievedUser)
              
              const profileReviewToSet = retrievedUser.reviewerProfile.profileReviews.filter((profileReview, reviewIndex) => profileReview._id === profileReviewId)[0]
              setProfileReview(profileReviewToSet)

              setLoading(false)
            } else if (
              !isReviewer 
              && retrievedUser._id === payload.sub
              && 'datingProfiles' in retrievedUser
              && retrievedUser.datingProfiles.length > 0
              && retrievedUser.datingProfiles.filter((profile, index) => profile._id === datingProfileId).length > 0
              && 'profileReviews' in retrievedUser.datingProfiles.filter((profile, index) => profile._id === datingProfileId)[0]
              && retrievedUser.datingProfiles.filter((profile, index) => profile._id === datingProfileId)[0].profileReviews.length > 0
              && retrievedUser.datingProfiles.filter((profile, index) => profile._id === datingProfileId)[0].profileReviews.filter((reviewItem, reviewItemIndex) => reviewItem._id === profileReviewId).length > 0
              && retrievedUser.datingProfiles.filter((profile, index) => profile._id === datingProfileId)[0].profileReviews.filter((reviewItem, reviewItemIndex) => reviewItem._id === profileReviewId)[0].reviewSubmitted
            ) {
              // console.log('states should set - client')
              // Set User State
              setUser(retrievedUser)

              const profileReviewToSet = retrievedUser.datingProfiles.filter((profile, index) => profile._id === datingProfileId)[0].profileReviews.filter((reviewItem, reviewItemIndex) => reviewItem._id === profileReviewId)[0]
              // console.log('profileReviewToSet ->', profileReviewToSet)
              setProfileReview(profileReviewToSet)

              // if ('reviewerReview' in profileReviewToSet && profileReviewToSet.reviewerReview !== null) {
              setNewReviewerReview({
                email: profileReviewToSet.reviewerEmail,
                profileReviewId: profileReviewId,
                reviewerProfileId: profileReviewToSet.reviewerProfileId,
                starRating: 'reviewerReview' in profileReviewToSet && profileReviewToSet.reviewerReview !== null ? profileReviewToSet.reviewerReview.starRating : -1,
                reviewText: 'reviewerReview' in profileReviewToSet && profileReviewToSet.reviewerReview !== null ? profileReviewToSet.reviewerReview.reviewText : '',
                profileReviewedFirstName: retrievedUser.bio.vitalInfo.firstName,
              })
              // }

              setLoading(false)

            } else {
              console.log('states should not set')
              useNavigate(`/dashboard/${payload.sub}`)
              setLoading(false)
            }

          } catch (err) {
            // console.log(err)

            navigate('/')
            setLoading(false)
          }
        }
      }
  
      fetchData()
    }

  }, [])

  useEffect(() => {
    // console.log('showSubcaption useEffect Runs')
    // console.log('newReviewerReview ->', newReviewerReview)

  }, [showSubcaption, newReviewerReview, loadingReviewerReview])

  const handleBackToDashboardPressed = () => {
    // console.log('handleBackToDashboardPressed runs')
    if (!isDemo) {
      navigate(`/dashboard/${payload.sub}`, { state: { previousLocationPathname: window.location.pathname } })
    } else {
      // navigate(`/demo/${user.bio.vitalInfo.firstName.toLowerCase()}/dashboard`, { state: { previousLocationPathname: window.location.pathname } })
      if (fromHomepage) {
        navigate(`/`)
      } else {
        navigate(`/demo/`, { state: { previousLocationPathname: window.location.pathname } })
      }
    }
  }

  return (
    <>
      {/* Helmet — for analytics, seo, and page title changing */}
      {seoPageTags(
        (
          isDemo 
          && (demoUser && 'bio' in demoUser && 'vitalInfo' in demoUser.bio && 'firstName' in demoUser.bio.vitalInfo)
        ) 
          ? 
          `Demo — ${demoUser.bio.vitalInfo.firstName}` 
          : 
          'View Feedback'
      )}

      {/* Body */}

      {loading ?
        <Box sx={{ 
          width: '100%',
          // minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight} - ${dashboardNavbarHeight})`,
          minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight})`,
          mt: 0, mb: 0,
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', 
        }}>
          {standardSpinner()}
        </Box>
        : 
        <Box 
          sx={{ 
            width: '100%',
            minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight})`,
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', 
          }}
        >

          {/* Back to Dashboard Button */}
          <Box
            sx={{
              mb: 0,
              width: '100%',
              display: 'flex', flexDirection: width < positionChangeWidthSm ? 'column' : 'column', justifyContent: 'center', alignItems: 'center',
            }}
          >
            {standardButton(
              `Back to ${isDemo ? fromHomepage ? 'Home' : 'Demo' : 'Dashboard'}`, 
              'button',
              'text',
              false,
              'secondary', 
              width >= positionChangeWidthSm ? 2 : 2,
              0,
              0,
              '250px', 
              '45px', 
              handleBackToDashboardPressed
            )}
          </Box>

          <Box 
            sx={{ 
              mt: 1, mb: 4, 
              width: '100%', 
              maxWidth: '600px', 
              display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', 
            }}
          >

            {Object.keys(profileReview).length > 0
              && 'reviewSubmitted' in profileReview
              && profileReview.reviewSubmitted
              ?
              <>
                {profileReview.type === 'hinge'
                  ?
                  viewHingeProfileJSX(
                    true, 
                    false,
                    false,
                    profileReview, 
                    user, 
                    showSubcaption, 
                    setShowSubcaption,
                    mediaIsLoading, 
                    setMediaIsLoading,
                    loading, 
                    setLoading, 
                    errors, 
                    setErrors, 
                    width, 
                    setProfileReview
                  )
                  :
                  profileReview.type === 'bumble'
                    ?
                    viewBumbleProfileJSX(
                      true, 
                      false,
                      false,
                      profileReview, 
                      user, 
                      showSubcaption, 
                      setShowSubcaption,
                      mediaIsLoading, 
                      setMediaIsLoading,
                      loading, 
                      setLoading, 
                      errors, 
                      setErrors, 
                      width, 
                      setProfileReview
                    )
                    :
                    viewTinderProfileJSX(
                      true, 
                      false,
                      false,
                      profileReview, 
                      user, 
                      viewTinderImageIndex, 
                      setViewTinderImageIndex, 
                      showSubcaption, 
                      setShowSubcaption,
                      mediaIsLoading, 
                      setMediaIsLoading,
                      loading, 
                      setLoading, 
                      errors, 
                      setErrors, 
                      width, 
                      setProfileReview
                    )
                }

                {/* Reviewer */}
                <Box
                  sx={{
                    mt: 2, mb: 2, py: 3, px: 2,
                    backgroundColor: hingeProfileBackgroundColor,
                    // backgroundColor: 'black',
                    width: '100%', 
                    // maxWidth: '600px',
                    maxWidth: '400px',
                    boxShadow: 3, 
                    borderRadius: 3,
                    display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
                  }}
                >

                  {
                    (
                      !isReviewer 
                      // && (userId === payload.sub)
                    ) 
                      ? 
                      viewReviewerJSX(isDemo, profileReview, setProfileReview, width, newReviewerReview, setNewReviewerReview, reviewerReviewErrors, setReviewerReviewErrors, loadingReviewerReview, setLoadingReviewerReview) 
                      : 
                      viewReviewerJSX(isDemo, profileReview, setProfileReview, width)
                  }
                </Box>

                {/* Back to Dashboard Button */}
                <Box
                  sx={{
                    mb: 0,
                    width: '100%',
                    display: 'flex', flexDirection: width < positionChangeWidthSm ? 'column' : 'column', justifyContent: 'center', alignItems: 'center',
                  }}
                >
                  {standardButton(
                    `Back to ${isDemo ? fromHomepage ? 'Home' : 'Demo' : 'Dashboard'}`, 
                    'button',
                    'text',
                    false,
                    'secondary', 
                    width >= positionChangeWidthSm ? 2 : 2,
                    0,
                    0,
                    '250px', 
                    '45px', 
                    handleBackToDashboardPressed
                  )}
                </Box>
                

              </>
              :
              <Box>
                Review Not Yet Submitted
              </Box>
            }

          </Box>
        </Box>
      }
    </>
  )
}

export default ViewFeedback